import VueRouter from 'vue-router';
import MotabilityDetails from './views/motability-details.vue';

const routes = [
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|jeep|alfa-romeo|leapmotor)/motability/model/:id/:slug',
        name: 'motability-details',
        component: MotabilityDetails,
        props: true,
        meta: {},
    },
];

let scrollBehavior = function(to, from, savedPosition) {
    if (to.hash) {
        return {
            selector: to.hash
            , offset: {x:0, y:105}
        };
    }
    return { selector: 'body', offset: {x:0, y:105} };
};

export default new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior,
    base: '/',
    linkActiveClass: 'active',
});


// WEBPACK FOOTER //
// ./resources/assets/js/motability/routes.js